<template>
  <vx-card>

    <ejs-schedule
      id="Schedule"
      ref="ScheduleObj"
      :timeScale="timeScale"
      height="700px"
      :currentView='currentView'
      :eventSettings='eventSettings'
      :cssClass='cssClass'
      :show-header-bar="true"
      :workHours="workHours"
      :startHour="startHour"
      :endHour="endHour"
      :eventDoubleClick="false"
      :resource-header-template="resourceHeaderTemplate"
      :popupOpen="openpopup"
      :cellClick="onCellClick"
      :eventClick="onEventClick"
      :dragStart="dragStart"
      :dragStop="dragStop"
      :dataBinding="dataBinding"
      :allowTextWrap='true'
      :textWrapSettings='wrapSettings'
      :group='group'>
      <e-views>
        <e-view :eventTemplate="weekTemplate" option="Day"></e-view>
        <e-view :eventTemplate="weekTemplate" option="Week"></e-view>
        <e-view :eventTemplate="weekTemplate" option="TimelineDay" :allowVirtualScrolling="'true'"></e-view>
        <e-view :eventTemplate="weekTemplate" option="TimelineWeek"></e-view>
      </e-views>
      <e-resources>
        <e-resource field='ProjectId' title='Choose Project' name='Projects' :dataSource='projectResourceDataSource' textField='text'
                    idField='id' colorField='color'>
        </e-resource>
      </e-resources>
    </ejs-schedule>
    <view-work-order-pop-up v-on:refreshData="getWorkOrderList" ref="viewWorkOrderPopUp"/>
    <work-order-drag-pop-up v-on:refresh="refreshData" ref="workOrderDragPopUp"/>
  </vx-card>
</template>

<script>
  import Vue from 'vue'
  import {Day, DragAndDrop, Resize, SchedulePlugin, TimelineViews, Week} from "@syncfusion/ej2-vue-schedule";

  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import ViewWorkOrderPopUp from "@/components/popups/manufacturing/work-order/ViewWorkOrderPopUp";

  const ManufacturingRepository = RepositoryFactory.get('manufacturing')
  const SettingsRepository = RepositoryFactory.get('settings')

  import resourceHeaderTemplate from "./resourceHeaderTemplate";
  import weekTemplate  from "./weekTemplate";
  import WorkOrderDragPopUp from "@/components/popups/manufacturing/work-order/WorkOrderDragPopUp";
  Vue.use(SchedulePlugin);
  import moment from 'moment';


  export default Vue.extend({
    name: "Test",
    provide: {
      schedule: [Day, Week, TimelineViews, Resize, DragAndDrop]
    },
    data() {
      return {
        currentView: 'TimelineDay',
        live_production_lines: [],
        work_orders: [],
        selectedCell: {},
        loading: false,
        eventSettings: {
          enableTooltip: true,
          dataSource: [],
          ignoreWhitespace: true,
          enableMaxHeight: true
        },
        query: {
          date_from: '',
          date_to: ''
        },
        timeScale: { enable: true, interval: 120, slotCount: 10 },
        workHours: { highlight: true},
        startHour: '10:00',
        endHour: '20:00',
        projectResourceDataSource: [],
        group: {
          resources: ['Projects']
        },
        cssClass: 'schedule-event-template',
        resourceHeaderTemplate () {
          return {template: resourceHeaderTemplate}
        },
        weekTemplate () {
          return {template: weekTemplate}
        },
        wrapSettings: { wrapMode: 'Content' },
      }
    },
    components: {
      ViewWorkOrderPopUp,
      WorkOrderDragPopUp,
    },
    methods: {
      onClickSUbmit() {

      },
      async refreshData() {
        this.eventSettings.dataSource = []
        this.loading = true
        await this.getWorkOrderList()
        this.loading = false
      },
      async fetchSettings() {
        await this.$vs.loading({
          container: '#Schedule',
          scale: 0.45
        })
        const {data} =  (await SettingsRepository.getListOfSettings()).data
        this.startHour = this.__utcToLocalTime(data.working_hours.elements[0].value)
        this.endHour = this.__utcToLocalTime(data.working_hours.elements[1].value)
        this.$vs.loading.close('#Schedule > .con-vs-loading')
      },
      async getWorkOrderList() {
        if (!this.query.date_from || !this.query.date_to) return
        await this.$vs.loading({
          container: '#Schedule',
          scale: 0.45
        })
        try {
          const {data} = await ManufacturingRepository.getAllWorkOrdersDropdown(this.query.date_from, this.query.date_to)
          const confirmed_work_orders = data.data
          this.eventSettings = {dataSource: []}
          let events = []

          confirmed_work_orders.forEach((wo) => {
            const ob = {
              Subject: wo.work_order_code,
              ProjectId: wo.production_line_id.id,
              StartTime: moment(wo.work_order_date, 'DD/MM/YYYY').format('YYYY/MM/DD') + ' ' + this.__utcToLocalTime(wo.start_time),
              EndTime: moment(wo.work_order_date, 'DD/MM/YYYY').format('YYYY/MM/DD') + ' ' + this.__utcToLocalTime(wo.end_time),
              id: wo.id,
              status: wo.status
            }
            const clean_time = moment.duration(wo.formulation_clean_time, 'HH:mm').asMinutes()
            const ob_clean = {
              Subject: 'Clean Time',
              ProjectId: wo.production_line_id.id,
              StartTime: ob.EndTime,
              EndTime: moment(ob.EndTime, "YYYY/MM/DD HH:mm").add(clean_time, 'minutes').format('YYYY/MM/DD HH:mm'),
              id: wo.id,
              status: null,
              clean_time_data: {
                actual_start_clean_time: wo.actual_start_clean_time,
                actual_end_clean_time: wo.actual_end_clean_time
              }
            }
            events.push(ob)
            events.push(ob_clean)
          })
          this.eventSettings = {dataSource: events}

        } catch (e) {
        }
        this.$vs.loading.close('#Schedule > .con-vs-loading')
      },
      async getLiveProductionLineList() {
        await this.$vs.loading({
          container: '#Schedule',
          scale: 0.45
        })
        try {
          await this.fetchSettings()
          const {data} = await ManufacturingRepository.getLiveProductionLineList(1, '', 50)
          this.live_production_lines =  data.data
          this.projectResourceDataSource =  this.live_production_lines.map((m) => {
            return {text: m.production_line_code, id: m.id, color: '#ffffff', production_line_name: m.production_line_name, production_line_type: m.type}
          })
        } catch (e) {
        }
        this.$vs.loading.close('#Schedule > .con-vs-loading')
      },
      onDataBound: function() {
        let scheduleObj = this.$refs.ScheduleObj;
        if (
          ["Week", "WorkWeek"].indexOf(scheduleObj.ej2Instances.currentView) > -1
        ) {
          let appointments = scheduleObj.ej2Instances.element.querySelectorAll(
            ".e-appointment"
          );
          for (let i = 0; i < appointments.length; i++) {
            let eventData = scheduleObj.getEventDetails(appointments[i]);
            if (!scheduleObj.isSlotAvailable(eventData)) {

            }
            appointments[i].style.width = "100%";
            appointments[i].style.left = "0%";
          }
        }
      },
      openpopup (agrs) {
        if (!agrs.data.Guid) {
          agrs.cancel = true
          this.selectedCell = agrs
        }
        agrs.cancel = true
      },
      async onEventClick(agrs) {
        this.selectedCell = await agrs
        this.$refs.viewWorkOrderPopUp.openPopup(this.selectedCell.event.id)
      },
      async onCellClick(agrs) {
        this.selectedCell = await agrs
        agrs.cancel = true
      },
      dragStart(event) {

      },
      dragStop(event) {
        if(event.data.status) {
          this.$refs.workOrderDragPopUp.openPopup(event.data)
        }
      },
      async dataBinding (val) {
        this.query.date_from = moment(val.query.params.find(x => x.key === 'StartDate').value).format('DD/MM/YYYY')
        this.query.date_to = moment(val.query.params.find(x => x.key === 'EndDate').value).format('DD/MM/YYYY')
      }
    },
    watch: {
      'query.date_to' (values) {
        this.getWorkOrderList()
      },
    },
    async mounted() {
      this.loading = true
      await this.fetchSettings()
      await this.getLiveProductionLineList()
      if (this.$route.query.wo ) {
        await this.$refs.viewWorkOrderPopUp.openPopup(this.$route.query.wo)
      }
      this.loading = false
    }
  });


</script>

<style scoped>

  .schedule-container >>> .e-schedule .e-timeline-month-view .e-resource-left-td {
    width: 150px;
  }

  .schedule-container >>> .e-schedule .e-appointment-details {
    padding: 0 !important;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .e-vertical-view .e-content-wrap .e-appointment,
  .schedule-vue-sample .schedule-event-template.e-schedule .e-timeline-view .e-content-wrap .e-appointment {
    border-radius: 8px;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .e-vertical-view .e-content-wrap .e-appointment .e-appointment-details {
    padding: 0;
    height: 100%;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper {
    height: 100%;
    white-space: normal;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper .image {
    padding: 8px 0 4px;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper .image img {
    height: 100%;
    width: 100%;
    padding: 10px 25%;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper .subject {
    font-weight: 600;
    font-size: 15px;
    padding: 4px 4px 4px;
    height: 25px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper .time {
    height: 50px;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper .time,
  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper .description {
    font-size: 12px;
    padding: 4px 6px 4px;
    overflow: hidden;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .template-wrapper .footer {
    position: absolute;
    bottom: 0;
    height: 50px;
    width: 100%;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .e-timeline-view .e-appointment .e-appointment-details {
    padding: 0;
    height: 100%;
    width: 100%;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .e-timeline-view .template-wrapper {
    width: 100%;
  }

  .schedule-vue-sample .schedule-event-template.e-schedule .e-timeline-view .template-wrapper .subject {
    font-size: 16px;
    height: 36px;
    text-align: center;
    border-style: solid;
    border-width: 0 0px;
  }



</style>
